/**
 * Normalize MongoDB Decimal128 representations.
 * Values like "0E-6176" are MongoDB's way of storing zero in Decimal128 format.
 * This converts them to a readable "0".
 */
export function normalizeDecimal(value: unknown): string {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  if (!text) return "";
  // Handle MongoDB Decimal128 zero representations like "0E-6176"
  if (/^0E[+-]?\d+$/i.test(text)) return "0";
  return text;
}

/**
 * Returns the normalized decimal value or a dash "-" if empty.
 */
export function valueOrDash(value: unknown): string {
  const text = normalizeDecimal(value);
  return text || "-";
}

/**
 * Recursively convert empty strings to null in an object.
 * Prevents backend decimal128 parse errors for empty numeric fields.
 */
export function emptyStringsToNull<T>(obj: T): T {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === "string") return (obj === "" ? null : obj) as T;
  if (Array.isArray(obj)) return obj.map(emptyStringsToNull) as T;
  if (typeof obj === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
      result[key] = emptyStringsToNull(value);
    }
    return result as T;
  }
  return obj;
}
